import { render } from "./FormResult.vue?vue&type=template&id=2b16c345&scoped=true"
import script from "./FormResult.vue?vue&type=script&lang=js"
export * from "./FormResult.vue?vue&type=script&lang=js"

import "./FormResult.vue?vue&type=style&index=0&id=2b16c345&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b16c345"]])

export default __exports__